import DraggableModal from 'components/organisms/draggableModal';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseForm from 'components/atoms/base-form';
import { WrapUpForm } from 'components/organisms/device-troubleshoot-templates/templates/deviceTroubleshootForm';
import FormItemWrapper from 'components/molecules/rpm-alert-assessment/formItemWrapper';

import s from '../../styles.module.scss';
import { useWrapUp } from '../../hooks/use-wrap-up-modal';
import { useStoreModalValue } from '../../hooks/use-store-modal-value';
import { wrupUpValidationSchema } from '../../validation-schema';

import type { IWrapUpModalProps } from '../../types';
import type { FC } from 'react';

const WrapUpModal: FC<IWrapUpModalProps> = ({
  isOpen,
  handleSubmit,
  closeModal,
  patientGuid,
  whichPerson,
  otherPerson,
}) => {
  const { t } = useTranslation();
  const { initialValues, onSaveForm } = useWrapUp({
    closeModal,
    handleSubmit,
    whichPerson,
    otherPerson,
  });

  const type = 'min';

  type TInitialValues = typeof initialValues;
  const { parsedData, setModalValuesToStorage } =
    useStoreModalValue<TInitialValues>({
      modalName: `wrapUp_${patientGuid}`,
    });

  const formik = useFormik({
    initialValues: parsedData ?? initialValues,
    onSubmit: (data) => {
      setModalValuesToStorage(data);
      onSaveForm(data);
    },
    validateOnChange: false,
    validationSchema: wrupUpValidationSchema(),
  });

  const onSave = () => {
    formik.submitForm();
  };

  const needConsumables = 'needConsumables';
  const hasQuestions = 'hasQuestions';
  const reminderTakeReadingsRegularly = 'reminderTakeReadingsRegularly';
  const goalToUseDevice = 'goalToUseDevice';

  return (
    <>
      <DraggableModal
        isOpen={isOpen}
        toggle={closeModal}
        title={t('labels.RPMSpecialistTemplate')}
        onSave={onSave}
        dataCy="RPMSpecialistTemplate"
      >
        <BaseForm formik={formik}>
          <div className={s.wrapper}>
            {WrapUpForm.map((formItem, index) => {
              const fieldValue = formik.getFieldMeta(formItem.name)?.value;

              let isShowExtraFields = false;
              if (formItem.name === needConsumables) {
                isShowExtraFields = fieldValue === 'yes';
              } else if (formItem.name === reminderTakeReadingsRegularly) {
                isShowExtraFields = fieldValue?.length > 0;
              } else if (formItem.name === hasQuestions) {
                isShowExtraFields = true;
              }

              let isShowExtraExtraFields = false;
              if (
                formItem.name === reminderTakeReadingsRegularly &&
                fieldValue?.includes(
                  'Encouraged patient to continue taking their readings regularly',
                )
              ) {
                const goalToUseDeviceValue =
                  formik.getFieldMeta(goalToUseDevice)?.value;
                isShowExtraExtraFields =
                  goalToUseDeviceValue?.includes('Other');
              }

              return (
                <FormItemWrapper
                  formik={formik}
                  index={index}
                  formItem={formItem}
                  type={type}
                  requiredSymptomFields={[]}
                  isShowExtraFields={isShowExtraFields}
                  isShowExtraExtraFields={isShowExtraExtraFields}
                />
              );
            })}
          </div>
        </BaseForm>
      </DraggableModal>
    </>
  );
};

export default WrapUpModal;
